import CONFIG from "../appconfig.json";
import axios from "axios";
import { GetAuthorisationHeaderGroup } from "./assetxphelpers";

export const datacleansingstate = {
  namespaced: true,
  state: {
    orphanedAttributeValues: [],
    loading: false,
    deletingValueId: null,
    deletingAll: false,
    error: null,
  },
  mutations: {
    SetOrphanedAttributeValues(state, values) {
      state.orphanedAttributeValues = values || [];
    },
    SetLoading(state, loading) {
      state.loading = loading;
    },
    SetDeletingValueId(state, valueId) {
      state.deletingValueId = valueId;
    },
    SetDeletingAll(state, deletingAll) {
      state.deletingAll = deletingAll;
    },
    SetError(state, error) {
      state.error = error;
    },
  },
  actions: {
    async GetOrphanedAttributeValues({ commit }) {
      commit("SetLoading", true);
      commit("SetError", null);

      try {
        const response = await axios.get(
          CONFIG.platformEndpoints.assetxpapi + "datacleansing/attributevalues/orphaned",
          GetAuthorisationHeaderGroup()
        );
        commit("SetOrphanedAttributeValues", response.data || []);
        return response.data || [];
      } catch (error) {
        commit("SetError", "Failed to load orphaned attribute values.");
        throw error;
      } finally {
        commit("SetLoading", false);
      }
    },

    async DeleteOrphanedAttributeValue({ commit, dispatch }, valueId) {
      commit("SetDeletingValueId", valueId);
      commit("SetError", null);

      try {
        await axios.delete(
          CONFIG.platformEndpoints.assetxpapi + "datacleansing/attributevalues/orphaned/" + valueId,
          GetAuthorisationHeaderGroup()
        );
        await dispatch("GetOrphanedAttributeValues");
      } catch (error) {
        commit("SetError", "Failed to delete attribute value.");
        throw error;
      } finally {
        commit("SetDeletingValueId", null);
      }
    },

    async DeleteAllOrphanedAttributeValues({ commit, dispatch }) {
      commit("SetDeletingAll", true);
      commit("SetError", null);

      try {
        const response = await axios.post(
          CONFIG.platformEndpoints.assetxpapi + "datacleansing/attributevalues/orphaned/deleteall",
          {},
          GetAuthorisationHeaderGroup()
        );
        await dispatch("GetOrphanedAttributeValues");
        return response.data;
      } catch (error) {
        commit("SetError", "Failed to delete all orphaned attribute values.");
        throw error;
      } finally {
        commit("SetDeletingAll", false);
      }
    },
  },
};
